<template>
  <div>
    <div class="section">
      <div class="box">
        <table class="table is-fullwidth">
          <tr>
            <th>Date</th>
            <th>Service</th>
            <th>Counter</th>
            <th>Bank</th>
            <th>EDC</th>
            <th>Giving</th>
            <th>Event</th>
            <th>Payment</th>
            <th>Member</th>
            <th>Total</th>
          </tr>
          <tr v-for="(transactions_row, index) in transactions_list" :key="index">
            <td v-text="transactions_row.date_time"></td>
            <td v-text="transactions_row.service"></td>
            <td v-text="transactions_row.counter"></td>
            <td v-text="transactions_row.edc_bank"></td>
            <td v-text="transactions_row.edc"></td>
            <td v-text="transactions_row.giving"></td>
            <td v-text="transactions_row.event"></td>
            <td v-text="transactions_row.payment"></td>
            <td v-text="transactions_row.member"></td>
            <td v-text="transactions_row.total"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      transactions_list: []
    }
  },
  created () {
    this.getTransactionsList()
  },
  methods: {
    getTransactionsList () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('frontdesk/get_transactions_list', {
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.transactions_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Transactions.vue